import { HubDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { useConfirmationAction } from '../../../hooks/confirmation-action.hook';
import { useMutationDeleteHub } from '../../hubs.queries';
import {
  ConfirmationModal,
  ConfirmationNote
} from '../../../../ui/components/pure/modal-content/confirmation-modal.component';

export function DeleteHubModal({
  hub,
  projectID,
  onAbort,
  onSuccess
}: {
  hub: HubDto;
  projectID: string;
  onAbort(): void;
  onSuccess(): void;
}) {
  const { onConfirm, state } = useConfirmationAction({
    mutationHook: useMutationDeleteHub,
    mutationArgs: (note?: ConfirmationNote) => ({
      projectID: projectID,
      hubID: hub.id,
      note: {
        content: note?.content ?? '',
        private: note?.visibility === 'private'
      }
    }),
    onSuccess,
    modalCloseDelay: 300
  });

  return (
    <ConfirmationModal
      title="Delete Hub"
      content={[
        'This should only be used when the hub will never be used again.',
        'It will no longer be visible in the portal.'
      ]}
      noteRequired
      noteMessage="Why are you deleting this hub?"
      onConfirm={onConfirm}
      onCancel={onAbort}
      actionButton={{
        label: 'Delete',
        color: 'danger'
      }}
      cancelButton={{
        label: 'Cancel'
      }}
      {...state}
    />
  );
}
